export default __webpack_public_path__ + "static/media/faceBotC.0dd1e35a.png";